// @flow
import SingleDatePicker from './SingleDatePicker'
import { createFormGroup } from '@src/components/ui/FormGroup'

export default createFormGroup(SingleDatePicker)
